import {
   appendTestableCustomAttribute,
   appendTestableElementAttributes,
   ClassNameProp,
   PaymentsIcon,
   StandardSpinner,
} from '@dreryk/react-components';

import { useVisitSettlementStatusGlobalState } from '../shared/statusResolver/useVisitSettlementStatusGlobalState';

import { StyledVisitSettlementStatusIcon } from './VisitSettlementStatusIcon.styled';

type VisitSettlementStatusIconProps = ClassNameProp & {
   readonly appointmentId: number;
};

export const VisitSettlementStatusIcon = (props: VisitSettlementStatusIconProps): JSX.Element => {
   const { getStatus } = useVisitSettlementStatusGlobalState();
   const status = getStatus(props.appointmentId);

   return (
      <StyledVisitSettlementStatusIcon
         {...appendTestableElementAttributes('icon')}
         {...appendTestableCustomAttribute('settlementStatus', status)}
         {...appendTestableCustomAttribute('visitId', props.appointmentId)}
         className={props.className}
         $status={status}
      >
         {status ? <PaymentsIcon /> : <StandardSpinner />}
      </StyledVisitSettlementStatusIcon>
   );
};
